export const my_trips_events = {
  my_trips_page_load: {
    category: "My trips page loads",
    action: "User navigates to my trips page",
    label: "my-trips-page-load",
  },
  back_my_trips: {
    category: "My Trips",
    action: "User goes back from My Trips",
    label: "my-trips-back-click",
  },
  back_saved: {
    category: "Navigation",
    action: "User navigates back from saved trips section",
    label: "saved-trips-back-click",
  },
  back_history: {
    category: "Navigation",
    action: "User navigates back from history section",
    label: "history-back-click",
  },
  history_item_click: {
    category: "Navigation",
    action: "User navigates back from history section",
    label: "history-item-click",
  },
  my_trips_upcoming_tab_click: {
    category: "User navigates to upcoming trips",
    action: "User clicks on upcoming button",
    label: "my-trips-upcoming-tab-click",
  },
  my_trips_past_tab_click: {
    category: "User clicks on past trips button",
    action: "User navigates to past trips",
    label: "my-trips-past-tab-click",
  },
  my_trips_cancelled_tab_click: {
    category: "User navigates to cancelled trips",
    action: "User clicks on cancelled trips button",
    label: "my-trips-cancelled-tab-click",
  },
  my_trips_shared_tab_click: {
    category: "User navigates to shared trips",
    action: "User clicks on shared trips button",
    label: "my-trips-shared-tab-click",
  },
  my_trips_saved_tab_click: {
    category: "User navigates to saved trips",
    action: "User clicks on saved trips tab",
    label: "my-trips-saved-tab-click",
  },
  my_trips_upcoming_trips_card_click: {
    category: "User navigates to trip details of upcoming trips",
    action: "User clicks on upcoming trips card",
    label: "my-trips-upcoming-card-click",
  },
  my_trips_past_trips_card_click: {
    category: "User navigates to trip details of past trips",
    action: "User clicks on past trips card",
    label: "my-trips-past-card-click",
  },
  my_trips_cancelled_trips_card_click: {
    category: "User navigates to trip details of cancelled trips",
    action: "User clicks on cancelled trips card",
    label: "my-trips-cancelled-card-click",
  },
  my_trips_shared_trips_card_click: {
    category: "User navigates to trip details of shared trips",
    action: "User clicks on shared trips card",
    label: "my-trips-shared-card-click",
  },
  my_trips_saved_trips_card_click: {
    category: "User navigates to trips details of saved trips",
    action: "User clicks on saved trips card",
    label: "saved-trips-card-click",
  },
    saved_trips_edit_close_click: {
    category: "Saved Trips",
    action: "User closes edit saved trip",
    label: "saved-trips-edit-close-click",
  },
  saved_trips_edit_name_click: {
    category: "Saved Trips",
    action: "User clicks to edit saved trip name",
    label: "saved-trips-edit-name-click",
  },
  saved_trips_edit_save_click: {
    category: "Saved Trips",
    action: "User saves edited trip name",
    label: "saved-trips-edit-save-save-click",
  },

  my_trips_upcoming_trips_edit_click: {
    category: "User clicks upcoming trips edit icon",
    action: "User clicks on edit icon for upcomings trips card",
    label: "my-trips-upcoming-edit-click",
  },
  edit_trip_new_trip_name_click: {
    category: "Edit trip",
    action: "User clicks to enter a new trip name",
    label: "my-trips-upc-edit-trip-name-click",
  },
  my_trips_past_edit_trip_name_click: {
    category: "My Trips",
    action: "User clicks to edit trip name for past trips",
    label: "my-trips-past-edit-trip-name-click",
  },
  my_trips_past_name_save_click: {
    category: "My Trips",
    action: "User saves edited trip name for past trips",
    label: "my-trips-past-name-save-click",
  },
  edit_trip_name_modal_close: {
    category: "Edit trip",
    action: "User closes edit trip name modal",
    label: "my-trips-upc-edit-trip-name-close-click",
  },
  my_trips_upc_edit_trip_name_close_click: {
    category: "My Trips",
    action: "User closes edit trip name for upcoming trips",
    label: "my-trips-upc-edit-trip-name-close-click",
  },
  my_trips_past_edit_trip_name_close_click: {
    category: "My Trips",
    action: "User closes edit trip name for past trips",
    label: "my-trips-past-edit-trip-name-close-click",
  },
  my_trips_cnc_edit_trip_name_close_click: {
    category: "My Trips",
    action: "User closes edit trip name for cancelled trips",
    label: "my-trips-cnc-edit-trip-name-close-click",
  },
  my_trips_past_trips_edit_click: {
    category: "User clicks past trips edit icon",
    action: "User clicks on edit icon for past trips card",
    label: "my-trips-past-edit-click",
  },
  my_trips_cancelled_trips_edit_click: {
    category: "User clicks cancelled trips edit icon",
    action: "User clicks on edit icon for cancelled trips card",
    label: "my-trips-cancelled-edit-click",
  },
  my_trips_shared_trips_edit_click: {
    category: "User clicks shared trips edit icon",
    action: "User clicks on edit icon for shared trips card",
    label: "my-trips-shared-edit-click",
  },
  my_trips_shared_edit_trip_name_close_click: {
    category: "My Trips",
    action: "User closes edit trip name for shared trips",
    label: "my-trips-shared-edit-trip-name-close-click",
  },
  saved_trips_edit_click: {
    category: "User clicks saved trips edit icon",
    action: "User clicks on edit icon for saved trips card",
    label: "saved-trips-edit-click",
  },
  my_trips_past_trips_book_again_click: {
    category: "User clicks to book the past trip",
    action: "User clicks on book again button in past trip card",
    label: "my-trips-past-book-again-click",
  },
  my_trips_cancelled_trips_book_again_click: {
    category: "User clicks to book the cancelled trip",
    action: "User clicks on book again button in cancelled trip card",
    label: "my-trips-cancelled-book-again-click",
  },
  my_trips_saved_trips_book_click: {
    category: "User clicks to book the saved trip",
    action: "User clicks on book button in saved trip card",
    label: "saved-trips-book-click",
  },

  my_trips_need_help: {
    category: "User need help on my trips page",
    action: "User clicks need help button",
    label: "my-trips-need-help-click",
  },
    need_help_back_click: {
    category: "Need Help",
    action: "User clicks back in need help section",
    label: "need-help-back-click",
  },
  need_help_email_us_click: {
    category: "Need Help",
    action: "User clicks email us in need help section",
    label: "need-help-email-us-click",
  },
  need_help_phone_click: {
    category: "Need Help",
    action: "User clicks phone support in need help section",
    label: "need-help-phone-click",
  },

  edit_trip_name_save_changes: {
    category: "User clicks to edit the trip name",
    action: "User clicks on save changes button in edit trip name popup",
    label: "my-trips-upc-name-save-click",
  },
};
